<template class="text-NotoSansRegular textColorDarkBlack">
  <v-select
    id="mySelect"
    :options="optionData"
    label="name"
    @input="setSelected"
    v-model="selected"
    :value="selected"
    :filter="fuseSearch"
    placeholder="請選擇或輸入搜索"
    >
    <span slot="no-options">查無資料</span>

    <template slot="option" slot-scope="data">
      ({{ data.code }}) {{ data.name }}
    </template>

  </v-select>

</template>

<script>
import Fuse from 'fuse.js'
export default {
  name: 'vueSelect',
  components: {
  },
  props: {
    optionData: {
      type: Array
    },
    userDonation: {
      type: String
    }
  },
  data () {
    return {
      selected: ''
    }
  },
  mounted () {
    this.initFunc()
  },
  computed: {
  },
  methods: {
    setSelected (value) {
      let self = this
      if (value) {
        self.selected = value
        self.$emit('inputLoveCode', value.code)
      } else {
        self.$emit('inputLoveCode', null)
      }
    },
    fuseSearch (options, search) {
      const fuse = new Fuse(options, {
        keys: ['code', 'name'],
        shouldSort: true
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },

    initFunc () {
      let self = this

      if (self.optionData && self.userDonation) {
        let index = self.optionData.findIndex(x => x.code === self.userDonation)
        if (index > -1) {
          self.selected = self.optionData[index]
        } else {
          // self.selected = self.data[0]
        }
      }
    }
  }
}
</script>

<style lang="scss">
#mySelect {
  .vs__dropdown-toggle {
    padding: 0 !important;
    border: none !important;
  }
  .vs__dropdown-menu::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
  }

  .vs__dropdown-menu::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .vs__dropdown-menu::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
  }
  .vs__selected {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
